import React from 'react';
import { useState, useEffect } from 'react'
import { Container, Button, Form } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { Icon } from '@material-ui/core';
import { useHistory } from "react-router-dom";

import ic_role_manage from '../images/ic_role_manage.svg'
import AddApplication from "./modal/AddApplication"
// import StepRoleCreate from "./StepRoleCreate"
import AddMemberToRole from "./AddMemberToRole"

import empty from "is-empty";
//const cookies = new Cookies()


import { createRole } from '../service'

import Header from './layout/Header'
import { reqAppList } from '../service/service';

const RoleCreate = () => {
    let history = useHistory();
    const [currentStep, setCurrentStep] = useState(1);
    const [errors, setErrors] = useState({});
    const [apps, setApps] = useState([])
    // const [permissionSetting, setPermissionSetting] = useState([])

    const [appList, setAppList] = useState([])

    const handleSetApp = (param, permissions) => {
        // console.log(param)
        // console.log(permissions)
        setApps([...apps, {
            route: param,
            permission: {
                "_id": "600c0cb01a26e105df465772",
                "name": "all"
              },
            permissions: permissions
        }])
        // setPermissionSetting([...permissionSetting, permission])
    }


    useEffect(() => {
        function reqApps() {
            reqAppList().then(res => {
                setAppList(res.result)
                // if (res.result.length > 0) {
                //     setAppValue(res.result[0].id)
                // }
            }).catch(_err => {

            })
        }
        reqApps()
        // requestPermissions()
    }, [])


    const [validated, setValidated] = useState(false);
    const [state, setState] = React.useState({
        roleName: '',
        departmentName: 'Department Name',
        permissionSetting: [],
        users: [],
        apps: []
    });
    function _Confirm(event) {
        const { roleName, users } = state
        if (users.length === 0) {
            Swal.fire(
                'Validater',
                'Select at least 1 person!',
                'error'
            )
        } else {
            console.log(apps)
            const params = {
                apps,
                "name": roleName,
                "users": users,
                // permissions: permissionSetting.length > 0 ? true :false
            }
            // console.log(params)
            createRole(params).then(res => {
                if (res.code === 200) {
                    history.push('/')
                    history.go(0)
                }
            }).catch(err => {
                console.log(err)
            })
        }
    }
    function _next(event) {
        const form = document.getElementById('my-form');
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        } else {
            const allErrors = {};

            if (state.roleName.length > 100) {
                allErrors.roleName = "Role Name lenght than less 100 charactor";
            }
            if (!empty(allErrors)) {
                console.log(allErrors)

                setErrors(allErrors);
                setValidated(false);
            } else {
                setCurrentStep(2)
            }

        }
        setValidated(true);

    }
    function _prev() {
        setCurrentStep(1)
    }
    function previousButton() {
        if (currentStep === 1) {
            return (
                <>
                    <Button onClick={handleClickBack} variant="link" className="p-0">
                        <p className="text-muted" style={{ fontSize: "14px" }} >
                            <Icon style={{ paddingTop: "6px" }}>keyboard_arrow_left</Icon>Back</p>
                    </Button>
                    <h4 className="mb-4">Add Member To Role</h4>
                </>
            )
        }
        return (
            <>
                <Button onClick={_prev} variant="link" className="p-0">
                    <p className="text-muted" style={{ fontSize: "14px" }} >
                        <Icon style={{ paddingTop: "6px" }}>keyboard_arrow_left</Icon>Back</p>
                </Button>
                <h4 className="mb-4">Add Member To Role</h4>
            </>
        );
    }

    function goCancel() {
        history.push({
            pathname: '/',
            search: '',
        })
        history.go(0)
    }
    function nextButton(event) {
        if (currentStep < 2) {
            return (
                <Button variant="primary" type="submit" className="px-5" onClick={_next}>Next</Button>
            )
        }
        return (
            <>
                <Button variant="light" className="px-5 border mr-2" onClick={goCancel}>Cancel</Button>
                <Button variant="primary" className="px-5" type="submit" onClick={_Confirm}>Confirm</Button>
            </>
        );
    }
    function handleClickBack() {
        history.push("/");
        history.go()
    }



    const onSubmit = (event) => {
        if (event.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        } else {
            const { roleName } = state
            console.log(roleName)
        }
        setValidated(true);
    };



    return (
        <>
            <Header logo={ic_role_manage} navbarRight={nextButton} />
            {currentStep === 1 ?
                <Container style={{ "width": "720px" }} role="main" className="main-content bg-whiht mb-5" >
                    <Form onSubmit={onSubmit} validated={validated} id="my-form">
                        <div className='row flex-xl-nowrap'>
                            <div className='col-md-12'>
                                <div className='flex-column align-items-center justify-content-between'>
                                    <Button onClick={handleClickBack} variant="link" className="mt-5 p-0">
                                        <p className="text-muted" style={{ fontSize: "14px" }} >
                                            <Icon style={{ paddingTop: "6px" }}>keyboard_arrow_left</Icon>Back</p>
                                    </Button>
                                    <h4 className="mb-4">Create Group</h4>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className="form-group">
                                    <div className="d-flex">
                                        <label htmlFor="roleName">Group Name <span className="text-danger">*</span></label>
                                        {/* <label htmlFor="roleName" className="text-muted d-inline-flex ml-auto">({roleName.length}/100) Max 100 characters</label> */}
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="InputRoleName"
                                        name="roleName"
                                        // defaultValue={roleName}
                                        required={true}
                                        onChange={(e) => setState({ ...state, roleName: e.target.value })}
                                        // onChange={e => props.handleChange(data => ({ ...data, roleName: e.target.value }))}
                                        placeholder="Group Name"

                                    />
                                    <div className="invalid-feedback">
                                        {errors.roleName}
                                    </div>
                                    {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                </div>
                            </div>
                        </div>
                        {apps.length > 0 ? apps.map((app, index) => (
                            <>
                            {console.log(app)}
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='border border-top border-primary w-100 my-4'></div>
                                        <div className="form-group w-75">
                                            <label htmlFor="InputApp">Application Access</label>
                                            <h5>{app?.route?.name}</h5>
                                            {/* <h5>{appList[index].name }</h5> */}
                                            {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                        </div>
                                    </div>
                                </div>
                                {/* <>{console.log(permissionSetting)}</> */}
                                {/* <div className='row'>
                                    {app.permissions.map((p, i) => (<div className='col-md-6'>
                                        <div className='border-bottom py-2'>
                                            <label htmlFor={`custom-checkbox-${i}`} className="pr-4 pl-1 d-flex justify-content-between align-items-center mr-2">
                                                <label htmlFor={`custom-checkbox-${i}`} className='mb-0'>{p.name} </label>
                                                <div className="chiller_cb">
                                                    <input id="myCheckbox" type="checkbox" checked={p.is_enable} />
                                                    <span></span>
                                                </div>
                                            </label>
                                        </div>
                                    </div>))}

                                </div> */}
                            </>
                        )) : <></>}

                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='d-flex justify-content-end my-3'>
                                    <AddApplication appList={appList} apps={apps} setApps={handleSetApp}></AddApplication>
                                </div>
                            </div>
                        </div>


                        {/* <>
                        <StepRoleCreate
                            currentStep={currentStep}
                            data={state}
                            errors={errors}
                            handleChange={setState}
                            nextButton={nextButton}
                            previousButton={previousButton}
                        />
                        <AddMemberToRole
                            currentStep={currentStep}
                            nextButton={nextButton}
                            data={state}
                            errors={errors}
                            handleChange={setState}
                            previousButton={previousButton}
                        />
                    </> */}
                    </Form>
                </Container> : <AddMemberToRole
                    currentStep={currentStep}
                    nextButton={nextButton}
                    data={state}
                    errors={errors}
                    handleChange={setState}
                    previousButton={previousButton}
                />}
        </>
    )
}

export default RoleCreate